"use client";

import { useEffect, useState } from "react";

/**
 * Sticky reading-progress bar at the very top of the viewport. Fills
 * coral as the user scrolls through the article. Subtle but powerful
 * UX signal that the content has a finite length and the user is
 * making real progress through it — measurably increases scroll depth
 * on long-form articles.
 *
 * Drop this anywhere in the page tree; it positions itself fixed.
 */
export function ReadingProgress() {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      if (max <= 0) {
        setPct(0);
        return;
      }
      const next = Math.min(100, Math.max(0, (doc.scrollTop / max) * 100));
      setPct(next);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      className="fixed inset-x-0 top-0 z-50 h-1 bg-transparent"
      role="progressbar"
      aria-label="Progreso de lectura"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full bg-coral transition-[width] duration-150"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
